import React, { useEffect } from 'react';
import { Check, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Container, EyebrowLabel, SectionTitle } from '../components/Section';
import HeroBanner from '../components/HeroBanner';
import { expertiseAreas, capabilities } from '../mock';

export default function Expertise() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-[#FAF7F5]">
      <HeroBanner
        image="/hero/expertise.jpg"
        overlay="default"
        height="min-h-[460px] lg:min-h-[540px]"
      >
        <div className="pt-[120px] lg:pt-[140px] pb-14 lg:pb-16">
          <Container>
            <div className="erbity-fade-up">
              <EyebrowLabel>Expertise</EyebrowLabel>
              <SectionTitle as="h1" className="mt-6 text-[44px] lg:text-[68px] leading-[1.04] max-w-4xl">
                From RTL to silicon <span className="italic text-[#7E2E4A]">bring-up</span>.
              </SectionTitle>
              <p className="mt-6 text-[17px] text-[#3B333A] max-w-2xl leading-relaxed erbity-fade-up-1">
                Our domain runs the full silicon design stack &mdash; semiconductor design,
                VLSI implementation and embedded engineering. Every recruiter is paired
                with an in-house engineer for technical screening.
              </p>
            </div>
          </Container>
        </div>
      </HeroBanner>

      <section className="pb-24">
        <Container>
          <div className="grid lg:grid-cols-3 gap-5">
            {expertiseAreas.map((a, i) => (
              <div key={a.title} className="relative bg-white rounded-3xl border border-[#EADDE2] p-8 flex flex-col">
                <div className="text-[11px] uppercase tracking-[0.22em] text-[#7A2E48]">0{i + 1} &middot; Capability</div>
                <h3 className="mt-4 font-serif text-[30px] text-[#1A1420]" style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}>{a.title}</h3>
                <p className="mt-4 text-[15px] text-[#4E434A] leading-relaxed">{a.description}</p>
                <ul className="mt-6 pt-6 border-t border-[#EADDE2] space-y-3">
                  {a.points.map((p) => (
                    <li key={p} className="flex items-center gap-3 text-[14px] text-[#1A1420]">
                      <span className="w-5 h-5 rounded-full bg-[#F2E3E8] flex items-center justify-center text-[#7E2E4A]"><Check size={11} /></span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="py-16 lg:py-20 bg-white border-y border-[#EADDE2]">
        <Container>
          <div className="max-w-2xl mb-10">
            <EyebrowLabel>Talent depth</EyebrowLabel>
            <SectionTitle className="mt-5 text-[32px] lg:text-[44px]">Twelve specialised talent pools, one team.</SectionTitle>
            <p className="mt-5 text-[15px] text-[#4E434A] leading-relaxed">
              We keep active pipelines across every semiconductor discipline &mdash; from
              RTL to power integrity &mdash; so shortlists arrive in days, not months.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {capabilities.map((c) => (
              <div key={c} className="px-4 py-4 rounded-xl bg-[#FAF7F5] border border-[#EADDE2] text-[13.5px] text-[#1A1420] hover:border-[#C4506F] transition-colors">{c}</div>
            ))}
          </div>
          <div className="mt-14">
            <Link to="/contact" className="group inline-flex items-center gap-2 bg-[#1A1420] text-white text-[15px] font-medium pl-6 pr-2 py-2 rounded-full hover:bg-[#3D1A2A] transition-colors">
              <span className="py-1">Request talent shortlist</span>
              <span className="w-10 h-10 rounded-full bg-[#C4506F] flex items-center justify-center group-hover:rotate-45 transition-transform duration-300">
                <ArrowUpRight size={16} />
              </span>
            </Link>
          </div>
        </Container>
      </section>
    </div>
  );
}
